<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading {{ $t('pageHeader.contacts') }}
    v-card-title
      v-text-field(v-model='search', append-icon='search', label='Search', single-line, hide-details clearable)
    v-data-table(:headers='headers' item-key="id" :items='contacts' :search="search" :loading='loading' :pagination.sync='pagination')
      template(slot='items' slot-scope='props')
        tr.pointer(@click="props.expanded = !props.expanded")
          td.text-xs-left {{ props.item.id }}
          td.text-xs-left {{ props.item.name }}
          td.text-xs-left {{ props.item.phoneNumber }}
          td.text-xs-left {{ props.item.email }}
      template(slot='expand' slot-scope='props')
        v-card
          v-card-text            

      v-alert(slot='no-results', :value='true', color='error', icon='warning')
        | Your search for "{{ search }}" found no results.
</template>

<script>
import { mapGetters } from "vuex"

export default {
  props: ['contacts', 'loading', 'title'],
  data() {
    return {
      headers: [
        {
          text: this.$t("labels.id"),
          value: "id",
          sortable: true,
        },
        {
          text: this.$t("labels.name"),
          value: "name",
          sortable: true,
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "phoneNumber",
          sortable: true,
        },
        {
          text: this.$t("labels.emailAddress"),
          value: "email",
          sortable: true,
        }
      ],
      search: null,
      pagination: {
        rowsPerPage: 10,
        sortBy: "id",
        descending: true
      }
    }
  },
  computed: {
    ...mapGetters("location", ["location"]),
    ...mapGetters("global", [
      "comboBox",
      "ComboBox",
      "comboBoxByID",
      "currentUser"
    ]),
  },
  methods: {
    gotoPageNewTab(data) {
      let routeData = this.$router.resolve({ path: `/tickets/profile/${data.id}`});
      window.open(routeData.href, '_blank');
    },
    gotoPage(data) {
      this.$router.push({ path: `/tickets/profile/${data.id}` })
    },
  }
}
</script>

<style scoped>
</style>